onComplete(function () {
	// Add code here.
	onComplete(function () {
		const header = document.querySelector('header.nav-header');
		const screenWidth = window.innerWidth;
		let prevScrollPos;
		let currentScrollPos = document.documentElement.scrollTop;
		window.addEventListener('scroll', function () {
			if (screenWidth > 768) {
				currentScrollPos = document.documentElement.scrollTop;
				if (prevScrollPos > currentScrollPos || prevScrollPos <= 0) {
					header.style.translate = "0 0";
				} else {
					header.style.translate = "0 -100%";
				}
				prevScrollPos = currentScrollPos;
			}
		});
	});

	// End sentence wrapper

	document.querySelectorAll("h1, h2, h3, h4, h5, h6, s").forEach(el => {
		el.innerHTML = el.innerHTML.replace(/([?!\.])(\s*)$/, '<span class="end-wrapper">$1</span>$2');
	});
});